'use client'

import React, { createContext, useContext } from 'react'

import {
  CATEGORY_ARCHIVE_SEGMENT,
  readShowCategoryBaseInSlugFromEnv,
  TAG_ARCHIVE_SEGMENT,
} from '@/constants/taxonomyRoutes'

export type TaxonomyArchivePathsValue = {
  /** Igual ao Yoast «stripcategorybase» inverso: `true` = prefixo na URL do arquivo. */
  showCategoryBaseInSlug: boolean
  /** Primeiro segmento do arquivo de categorias (`postUrlSettings.categoryUrlBase`). */
  categoryUrlBase: string
  /** Primeiro segmento do arquivo de tags (`postUrlSettings.tagUrlBase`). */
  tagUrlBase: string
}

const TaxonomyArchivePathsContext = createContext<TaxonomyArchivePathsValue>({
  showCategoryBaseInSlug: readShowCategoryBaseInSlugFromEnv(),
  categoryUrlBase: CATEGORY_ARCHIVE_SEGMENT,
  tagUrlBase: TAG_ARCHIVE_SEGMENT,
})

export function TaxonomyArchivePathsProvider({
  children,
  showCategoryBaseInSlug,
  categoryUrlBase,
  tagUrlBase,
}: {
  children: React.ReactNode
  showCategoryBaseInSlug: boolean
  categoryUrlBase: string
  tagUrlBase: string
}) {
  return (
    <TaxonomyArchivePathsContext.Provider
      value={{ showCategoryBaseInSlug, categoryUrlBase, tagUrlBase }}
    >
      {children}
    </TaxonomyArchivePathsContext.Provider>
  )
}

export function useTaxonomyArchivePaths(): TaxonomyArchivePathsValue {
  return useContext(TaxonomyArchivePathsContext)
}
